export const model = {
    id:  null,
    name: '',
    start:  "",
    end: '',
    active: ''
};
